import store from "../../store/store";
import { device } from "./reducers/device";
import search from "./reducers/search";
import { setDevicesInitialState } from "./actions/deviceActions";
export var prepareDevicesStore = function prepareDevicesStore(payload) {
  store.addReducer(device);
  store.dispatch(setDevicesInitialState(payload));
};
export var prepareSearchStore = function prepareSearchStore() {
  store.addReducer(search);
};